import {Text} from 'quickstart/components/content/Text'
import {ComponentProps} from 'react'

export const ErrorBox = (props: ComponentProps<typeof Text>) => (
  <Text
    p="md"
    border="std"
    borderColor="borderError"
    color="textError"
    bg="backgroundError"
    {...props}
  />
)
